/**
 * Un turno del hilo de la entrevista: la burbuja y, si toca, la tarjeta de
 * la voz o la de confirmación. Extraído de `Conversacion.tsx` por D4: la
 * conversación ya tiene bastante con decidir qué se pregunta y qué se guarda.
 */

import { ComoSuena, type Voz } from './ComoSuena';
import { type Propuesta, TarjetaDeConfirmacion } from './TarjetaDeConfirmacion';

export interface Turno {
  id: number;
  de: 'tibo' | 'dueno';
  texto: string;
  /** Lo que Tibo propone guardar. Sólo en sus turnos. */
  propuestas?: Propuesta[];
  /** El modelo no se pudo usar y esto es el texto del dueño, sin ordenar. */
  sinAsistente?: boolean;
  /**
   * La tarjeta de la voz, no una pregunta abierta: son tres datos —nombre,
   * tono, largo—, no texto, y por eso tiene ruta propia (GKTIBO-121).
   */
  esLaVoz?: boolean;
  resuelto?: 'guardado' | 'corrigiendo';
}

interface TurnoDeLaEntrevistaProps {
  turno: Turno;
  /** La inicial del negocio, para el turno del dueño. */
  inicial: string;
  tenantId: string;
  nombre: string;
  guardandoVoz: boolean;
  guardando: boolean;
  onGuardarVoz: (voz: Voz) => void;
  onGuardar: () => void;
  onCorregir: () => void;
}

export function TurnoDeLaEntrevista({
  turno,
  inicial,
  tenantId,
  nombre,
  guardandoVoz,
  guardando,
  onGuardarVoz,
  onGuardar,
  onCorregir,
}: TurnoDeLaEntrevistaProps) {
  return (
    <div className={`alta-chat-turno${turno.de === 'dueno' ? ' es-mio' : ''}`}>
      <span className="alta-chat-quien" aria-hidden="true">
        {turno.de === 'dueno' ? inicial : 'T'}
      </span>
      <div className="alta-chat-cuerpo">
        <p className="alta-chat-burbuja">{turno.texto}</p>

        {turno.esLaVoz && (
          <ComoSuena
            tenantId={tenantId}
            negocio={nombre}
            guardando={guardandoVoz}
            resuelto={turno.resuelto === 'guardado'}
            onGuardar={onGuardarVoz}
          />
        )}

        {turno.propuestas && (
          <TarjetaDeConfirmacion
            propuestas={turno.propuestas}
            sinAsistente={turno.sinAsistente}
            resuelto={turno.resuelto}
            guardando={guardando}
            onGuardar={onGuardar}
            onCorregir={onCorregir}
          />
        )}
      </div>
    </div>
  );
}
